/* eslint-disable promise/prefer-await-to-callbacks */

import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import 'zone.js'
import { AppModule } from './app/app.module'
import { environment } from './environments/environment'
import packageJson from '../../../package.json'

console.log(`Mountdoom-2 fce-components v${packageJson.version} environment ${environment.name}`)

if (environment.production) {
  enableProdMode()
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(error => console.error(error))
